import React, { useState } from 'react';
import { ChevronDown, Menu, X, Users, Scale, User, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from './Header';

const MainPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({});

  const toggleDropdown = (menu) => {
    setDropdownOpen(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Header */}
      <header className="bg-white border-b border-gray-300">
        <div className="pr-4 sm:pr-6 lg:pr-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <Link to="/">
                <img src="/logo.jpg" alt="Anand Rathi Logo" className="h-16 sm:h-20" />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-4 lg:space-x-8 text-gray-800 font-semibold text-sm lg:text-base">
              <div className="relative">
                <button
                  onClick={() => toggleDropdown('group')}
                  className="flex items-center hover:text-yellow-700 transition"
                >
                  GROUP <ChevronDown className="ml-1 h-4 w-4" />
                </button>
                {dropdownOpen.group && (
                  <div className="absolute top-full left-0 mt-1 w-48 bg-white shadow-lg border rounded-md z-50">
                    <Link to="/about" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">About</Link>
                    <Link to="/leadership" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Leadership</Link>
                    {/* <a href="#" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Our Journey</a> */}
                  </div>
                )}
              </div>
              {/* <button className="flex items-center hover:text-yellow-700 transition">
                                  BUSINESSES
                              </button>
                              <button className="hover:text-yellow-700 transition">MEDIA</button>
                              <button className="flex items-center hover:text-yellow-700 transition">
                                  CAREER
                              </button> */}
              <Link to="/contact" className="hover:text-yellow-700 transition">CONTACT US</Link>
            </nav>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t">
              <div className="space-y-2">
                <div>
                  <button
                    onClick={() => toggleDropdown('groupMobile')}
                    className="flex items-center justify-between w-full px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    GROUP <ChevronDown className="h-4 w-4" />
                  </button>
                  {dropdownOpen.groupMobile && (
                    <div className="pl-4 space-y-1">
                      <Link to="/about" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">About</Link>
                      <Link to="/leadership" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">Leadership</Link>
                     {/*<a href="#" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">Our Journey</a>*/}
                    </div>
                  )}
                </div>
                {/*<button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">BUSINESSES</button>
                <button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">MEDIA</button>
                <button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">CAREER</button>*/}
                <Link to="/contact" className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">CONTACT US</Link>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section with Background Image */}
      <section className="relative h-screen">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/frame5.png')`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-900/20"></div>
        </div>

        <div className="relative container mx-auto px-4 h-full flex items-center">
          <div className="bg-gray-900/90 text-white p-6 sm:p-8 lg:p-12 max-w-xs sm:max-w-md lg:max-w-lg">
            <h1 className="text-2xl sm:text-3xl lg:text-5xl font-bold mb-4 leading-tight">
              <span className="text-yellow-500">Your Financial</span><br />
              Well-being is<br />
              Our<br />
              Responsibility
            </h1>
            <div className="w-full h-1 bg-white mb-4 sm:mb-6 lg:mb-8"></div>
            <p className="text-gray-300 mb-4 sm:mb-6 lg:mb-8 text-sm sm:text-base">
              Financial innovation on a base of<br />
              a rich legacy
            </p>
            <div className="flex">
              <ChevronDown className="h-6 w-6 sm:h-8 sm:w-8 text-yellow-500 animate-bounce" />
            </div>
          </div>
        </div>
      </section>

      {/* Legacy Section */}
      <section className="py-10 sm:py-16 lg:py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 items-center">
            <div className="w-full lg:w-2/5 overflow-hidden shadow-xl">
              <img
                src="/frame14.png"
                alt="Anand Rathi Tower"
                className="w-full h-auto object-contain"
              />
            </div>
            <div className="hidden lg:flex items-center justify-center" style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}>
              <h2 className="text-3xl xl:text-5xl font-bold text-gray-800 tracking-wider transform rotate-180">The legacy</h2>
            </div>
            <div className="w-full lg:w-2/5">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 text-gray-800 lg:hidden text-center">The Legacy</h2>
              <p className="text-gray-600 leading-relaxed mb-4 text-sm sm:text-base">
                The Anand Rathi group came into existence close on the heels of economic liberalization. With
                an aim to channelise the new found hope and financial optimism into tangible results, Mr Anand
                Rathi and Mr Pradeep Kumar Gupta laid the foundation of the Anand Rathi Group in 1994. From
                setting up a research desk in 1995 to starting a capital market lending business in 2018, we have
                always kept the spirit of the centre of our plans.
              </p>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                An unwavering focus on ethics, entrepreneurial zeal and innovation has helped us thrive over
                the years. Our umbrella of services includes stock broking, wealth management, investment
                banking, commodities broking, construction finance and capital market lending, amongst
                others. With a dedicated client base of over 5 Lac Registered Customers, continued trust and
                support of our customers has been the most valuable legacy of the Anand Rathi Group.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Section */}
      <section className="py-10 sm:py-16 bg-gradient-to-br from-[#2a3a1a] to-[#3a4a22]">
        <div className="container mx-auto px-4">
          <div className="space-y-6 sm:space-y-8">
            {/* Founder 1 */}
            <div className="flex flex-col lg:flex-row items-center bg-gradient-to-r from-[#3a4a22] to-[#4a5a32] p-4 sm:p-6 lg:p-8 shadow-2xl gap-4 lg:gap-8">
              <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 flex-shrink-0">
                <img
                  src="/frame18.png"
                  alt="Anand Rathi"
                  className="w-full h-full object-cover shadow-lg border-2 border-gray-300 rounded"
                />
              </div>
              <div className="flex-1 flex flex-col lg:flex-row items-center text-center lg:text-left">
                <div className="mb-4 lg:mb-0 lg:mr-8">
                  <h3 className="text-white font-bold text-lg sm:text-xl mb-2 tracking-wide">ANAND RATHI</h3>
                  <p className="text-gray-300 text-sm">Founder & Group Chairman</p>
                </div>
                <div className="flex-1 relative">
                  <span className="text-white text-2xl sm:text-4xl absolute -top-1 sm:-top-2 -left-1 sm:-left-2">"</span>
                  <blockquote className="text-white text-sm sm:text-base leading-relaxed px-4 sm:px-6">
                    The founding idea behind the Anand Rathi Group was to democratise the idea of financial wellbeing in India. It has been our mission from the first day, to offer best-in-class financial services to our clients with utmost integrity and transparency.
                  </blockquote>
                  <span className="text-white text-2xl sm:text-4xl absolute -bottom-2 sm:-bottom-4 right-1 sm:right-2">"</span>
                </div>
              </div>
            </div>

            {/* Founder 2 */}
            <div className="flex flex-col lg:flex-row items-center bg-gradient-to-r from-[#3a4a22] to-[#4a5a32] p-4 sm:p-6 lg:p-8 shadow-2xl gap-4 lg:gap-8">
              <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 flex-shrink-0">
                <img
                  src="/frame18-1.png"
                  alt="Pradeep Gupta"
                  className="w-full h-full object-cover shadow-lg border-2 border-gray-300 rounded"
                />
              </div>
              <div className="flex-1 flex flex-col lg:flex-row items-center text-center lg:text-left">
                <div className="mb-4 lg:mb-0 lg:mr-8">
                  <h3 className="text-white font-bold text-lg sm:text-xl mb-2 tracking-wide">PRADEEP GUPTA</h3>
                  <p className="text-gray-300 text-sm">Co-Founder & Vice Chairman</p>
                </div>
                <div className="flex-1 relative">
                  <span className="text-white text-2xl sm:text-4xl absolute -top-1 sm:-top-2 -left-1 sm:-left-2">"</span>
                  <blockquote className="text-white text-sm sm:text-base leading-relaxed px-4 sm:px-6">
                    The Anand Rathi Group has been at the forefront of the financial revolution in the country. A laser-sharp focus on differentiated offerings and the urge to stay ahead of the innovation curve has been an integral part of our DNA.
                  </blockquote>
                  <span className="text-white text-2xl sm:text-4xl absolute -bottom-2 sm:-bottom-4 right-1 sm:right-2">"</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-10">
 
            {/* Left Title */}
            <div className="flex-shrink-0 text-center lg:text-left lg:h-full flex items-center justify-center">
              <h2
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800
          lg:transform lg:-rotate-90 lg:origin-center lg:whitespace-nowrap font-sans"
              >
                Core Values
              </h2>
            </div>
 
            {/* Right Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-6 flex-1 w-full">
 
              {/* Card 1 */}
              <div className="bg-[#C3A35B] rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-[1.02] duration-300">
                <img
                  src="/family.png"
                  alt="Family Culture"
                  className="w-full sm:h-56 lg:h-64 xl:h-72 2xl:h-96 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
 
              {/* Card 2 */}
              <div className="bg-[#C3A35B] rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-[1.02] duration-300">
                <img
                  src="/ethics.png"
                  alt="Integrity & Ethics"
                  className="w-full sm:h-56 lg:h-64 xl:h-72 2xl:h-96 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
 
              {/* Card 3 */}
              <div className="bg-[#C3A35B] rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-[1.02] duration-300">
                <img
                  src="/sprit.png"
                  alt="Entrepreneurial Spirit"
                  className="w-full sm:h-56 lg:h-64 xl:h-72 2xl:h-96 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
 
            </div>
          </div>
        </div>
      </section>
 
      {/*<section className="py-10 sm:py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8">
            <div className="bg-white p-4 sm:p-6 flex items-center justify-center lg:h-48">
              <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-gray-800 lg:whitespace-nowrap lg:transform lg:-rotate-90 lg:origin-center font-sans text-center lg:text-left">Core Values</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 flex-1 w-full">
              <div className="bg-[#C3A35B] p-4 sm:p-2 text-center shadow-lg aspect-square flex flex-col justify-center">
                              <div className="h-12 w-12 sm:h-16 sm:w-16 mx-auto mb-2 sm:mb-4 flex items-center justify-center">
                  <svg viewBox="0 0 100 100" className="w-full h-full" fill="white">
                    <g>
                      <circle cx="30" cy="25" r="8" />
                      <rect x="22" y="33" width="16" height="30" />
                      <circle cx="50" cy="25" r="8" />
                      <rect x="42" y="33" width="16" height="30" />
                      <circle cx="70" cy="25" r="8" />
                      <rect x="62" y="33" width="16" height="30" />
                    </g>
                  </svg>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2 font-sans">FAMILY</h3>
                <p className="text-white font-sans text-sm sm:text-base">CULTURE</p>
                <img
                    src={'/9.jpg'}
                    alt={'FAMILY CULTURE'}
                    className="w-full h-48 sm:h-56 lg:h-64 object-contain rounded bg-gray-100"
                />
              </div>

              <div className="bg-[#C3A35B] p-4 text-center shadow-lg aspect-square flex flex-col justify-center">
                              <div className="h-12 w-12 sm:h-16 sm:w-16 mx-auto mb-2 sm:mb-4 flex items-center justify-center">
                  <svg viewBox="0 0 100 100" className="w-full h-full" fill="white">
                    <g>
                      <rect x="10" y="40" width="80" height="4" />
                      <path d="M 15 44 L 10 55 L 30 55 L 25 44 Z" />
                      <path d="M 75 44 L 70 55 L 90 55 L 85 44 Z" />
                      <line x1="50" y1="20" x2="50" y2="44" stroke="white" strokeWidth="3" />
                    </g>
                  </svg>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2 font-sans">INTEGRITY</h3>
                              <p className="text-white font-sans text-sm sm:text-base">& ETHICS</p>
                <img
                    src={'/11.jpg'}
                    alt={'FAMILY CULTURE'}
                    className="w-full h-48 sm:h-56 lg:h-64 object-contain rounded bg-gray-100"
                />
              </div>

              <div className="bg-[#C3A35B] p-4 text-center shadow-lg aspect-square flex flex-col justify-center">
                              <div className="h-12 w-12 sm:h-16 sm:w-16 mx-auto mb-2 sm:mb-4 flex items-center justify-center">
                  <svg viewBox="0 0 100 100" className="w-full h-full" fill="white">
                    <g>
                      <path d="M 50 80 L 30 60 L 40 50 L 50 60 L 70 40 L 80 50 Z" strokeWidth="3" stroke="white" fill="none" />
                      <circle cx="50" cy="30" r="8" />
                      <rect x="42" y="38" width="16" height="25" />
                    </g>
                  </svg>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2 font-sans">ENTREPRENEURIAL</h3>
                              <p className="text-white font-sans text-sm sm:text-base">SPIRIT</p>
                <img
                    src={'/13.jpg'}
                    alt={'FAMILY CULTURE'}
                    className="w-full h-48 sm:h-56 lg:h-64 object-contain rounded bg-gray-100"
                />
              </div>
            </div>
          </div>
        </div>
      </section>*/}

      {/* Footer */}
      <footer className="bg-gradient-to-br from-[#3a4a22] to-[#5a6a3a] text-white">
        <div className="container mx-auto px-4 py-8">
          <div className="grid md:grid-cols-4 gap-8 mb-6">
            <div className="flex">
              <div className="w-1 bg-white mr-4"></div>
              <div>
                <h4 className="text-white font-bold mb-4 font-sans">REGISTERED OFFICE:</h4>
                <p className="text-sm text-[#D4C4A8] leading-relaxed font-sans">
                  1003 to 1012, 10th Floor, <br />
                    Dalal Street Commercial Cooperative Society Ltd.<br />
                    Block 53E, Zone-5, Road-5E, Gift City,<br />
                    District - Gandhinagar, Gujarat - 382355
                </p>
                <p className="text-sm text-[#D4C4A8] leading-relaxed font-sans mt-2">
                  Contact No. 022 6281 7003
                </p>
              </div>
            </div>
            <div className="flex">
              <div className="w-1 bg-white mr-4"></div>
              <div>
                <h4 className="text-white font-bold mb-4 font-sans">QUICK LINKS</h4>
                <div className="space-y-2 text-sm font-sans">
                  <Link to="/kyc-vernacular-language" className="block text-[#D4C4A8] hover:text-white transition">KYC Vernacular Language</Link>
                  <a href="https://smartodr.in/login" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">ODR Portal</a>
                  <a href="https://eservices.nsdl.com" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">NSDL E-Voting</a>
                  <a href="https://evoting.cdslindia.com/Evoting/EvotingLogin" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">CDSL E-Voting</a>
                </div>
              </div>
            </div>
            <div className="flex">
              <div className="w-1 bg-white mr-4"></div>
              <div>
                <h4 className="text-white font-bold mb-4 font-sans">OTHER LINKS</h4>
                <div className="space-y-2 text-sm font-sans">
                  <a href="#" className="block text-[#D4C4A8] hover:text-white transition">Companies and Associate Details</a>
                  <a href="#" className="block text-[#D4C4A8] hover:text-white transition">Company Profile</a>
                  <Link to="/client-bank-details" className="block text-[#D4C4A8] hover:text-white transition">Client Bank Details</Link>
                  <Link to="/advisory-on-impersonation" className="block text-[#D4C4A8] hover:text-white transition">Advisory on Impersonation</Link>
                  <Link to="/advisory-for-investors" className="block text-[#D4C4A8] hover:text-white transition">Advisory for Investors</Link>
                  <Link to="/investor-complaints" className="block text-[#D4C4A8] hover:text-white transition">Complaints</Link>
                  <Link to="/risk-disclosure-on-derivatives" className="block text-[#D4C4A8] hover:text-white transition">Risk Disclosure on Derivatives</Link>
                  <a href="/PDF/UPI-Handle.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Transfer of funds via SEBI-validated UPI ID</a>
                </div>
              </div>
            </div>
            <div className="flex">
              <div className="w-1 bg-white mr-4"></div>
              <div>
                <h4 className="text-white font-bold mb-4 font-sans">DOWNLOADS</h4>
                <div className="space-y-2 text-sm font-sans">
                                                                              <a href="/ARGIL-CRF-Form.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">CRF Form</a>
                                                                              <a href="/Investor-Charter.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Investor Charter</a>
                                                                              <a href="/PDF/RMS-Policy_merged.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">RMS Policy</a>
                                                                              <Link to="/privacy-policy" className="block text-[#D4C4A8] hover:text-white transition">Privacy Policy</Link>
                                                                              <a href="/PDF/Surveillance-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Surveillance Policy</a>
                                                                              <a href="/PDF/new-Client-Code-Modification-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Client Code Modification Policy</a>
                                                                              <a href="/PDF/new-PMLA-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">AML Policy</a>
                                                                              <a href="/PDF/Policy-regarding-pre-funded-instruments.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Policy Regarding Pre-Funded Instruments</a>
                                                                              <a href="/PDF/Policy-for-treatment-of-inactive-accounts.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Policy for Treatment of Inactive Accounts</a>
                                                                            </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-b from-gray-700 to-gray-800 py-6">
          <div className="container mx-auto px-4">
            <div className="space-y-4 text-xs text-gray-300 font-sans">
              <div>
                <p className="font-semibold text-white mb-2">Anand Rathi Global Intermediaries Ltd.</p>
                <p>CIN : U66120GJ2024PLC148630</p>
                <p>SEBI Registration No.: INZ000327038 (NSE- 90408)</p>
              </div>

              <div>
                <p className="font-semibold text-white mb-2">Disclaimer:</p>
                <div className="space-y-2 leading-relaxed">
                  <p>
                    Equity: Investment in securities market are subject to market risks, read all the related documents carefully before investing.
                    The securities are quoted as an example and not as a recommendation.
                  </p>
                  <p>
                    Mutual Funds: Mutual fund investments are subject to market risks, read all scheme related documents carefully before investing.
                  </p>
                  <p>
                    Certification/Registration granted by SEBI and certification from NISM is in no way a guarantee of performance of the intermediary or provides any assurance of returns to investors.
                  </p>
                </div>
              </div>

              <div>
                <p className="font-semibold text-white mb-3">Attention Investors:</p>
                <ul className="space-y-1 leading-relaxed">
                  <li>• For all communication related to vulnerability reporting, security alerts, or any other suspicious activity related to cyber security, contact argil@rathi.com</li>
                  <li>• For any complaints email at <a href="mailto:argilgrievance@rathi.com" className="text-yellow-400 hover:text-yellow-300">argilgrievance@rathi.com</a></li>
                  <li>• Filing of complaints on <a className="text-yellow-400 hover:text-yellow-300" href="https://scores.sebi.gov.in/" traget="_blank">SCORES portal</a> – Easy & quick a. Register on SCORES portal b. Mandatory details for filing complaints on SCORES: I. Name, PAN, Address, Mobile Number, Email ID c. Benefits: I. Effective communication ii. Speedy redressal of the grievances.</li>
                  <li>• Stock Brokers can accept securities as margin from clients only by way of pledge in the depository system w.e.f. September 1, 2020. </li>
                  <li>• Update your mobile number & email Id with your stock broker / depository participant and receive OTP directly from depository</li>
                  <li>• Pay 20% upfront margin of the transaction value to trade in cash market segment</li>
                  <li>• Check your Securities /MF/ Bonds in the consolidated account statement issued by NSDL/CDSL every month</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MainPage;